import React, {useState, useContext} from 'react';
import { translate } from 'react-multi-lang';
import * as XLSX from 'xlsx';
import { Table, Input, Button, Space, Tag, Tooltip } from 'antd';
import { SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { AllHtmlEntities } from 'html-entities';

import Moment from 'react-moment';
import moment from 'moment';

import ContainerPagina from '../../../components/ContainerPagina';
import TitolPagina from '../../../components/TitolPagina';
import TriaCursEscolar from '../../../components/TriaCursEscolar';
import LlistaEditable from '../../../components/LlistaEditable';
//import LlistaEditableModalNouEdit from '../../../components/LlistaEditableModalNouEdit';
import Edit from '../../../components/Formularis/perfils/admin/Extraescolars';
import { Api, InitDades } from '../../../helpers';
import { PerfilUsuariContext } from "../../../context/perfil-usuari";

const { Column } = Table;
const entities = new AllHtmlEntities();
moment.locale('es');

function Extraescolars(props) {

  const [perfilUsuari] = useContext(PerfilUsuariContext);
  const [cursEscolarTriat, setCursEscolarTriat] = useState(perfilUsuari.curs_escolar_actual.id);
  const [refrescar, setRefrescar] = useState(0);


  // 1. Definim un estat per guardar les dades filtrades/ordenades.
  // Inicialment, conté totes les dades.
  //const [dadesActuals, setDadesActuals] = useState(dadesInicials);
  const [dadesActuals, setDadesActuals] = useState([]);
  // 2. Capturem les dades reals de la taula quan l'usuari interactua amb ella
  const handleTableChange = (pagination, filters, sorter, extra) => {
    // 'extra.currentDataSource' té el conjunt de dades actual filtrat i ordenat
    setDadesActuals(extra.currentDataSource);
  };
  // 3. Funció per exportar l'estat actual a un fitxer .xlsx
  const exportarAExcel = () => {
    // Convertim l'array d'objectes JSON directament a una fulla d'Excel (worksheet)
    // Abans de passar-ho, podem mapejar les dades per polir els noms de les columnes
    /*const dadesNetejades = dadesActuals.map(({ key, ...rest }) => ({
      'Nom de l’Empleat': rest.nom,
      'Departament/Àrea': rest.departament,
      'Salari Mensual (€)': rest.salari,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dadesNetejades);*/

    const dadesNetejades = dadesActuals.map(({
      id, ordre,
      nom_t,
      horari_t,
      nom,               // L'extraiem perquè no quedi dins de "rest"
      horari,            // L'extraiem perquè no quedi dins de "rest"
      descripcio,
      mesos_facturacio,
      cursos,
      ...rest
    }) => ({
      id: id,
      ordre: ordre,
      nom: nom_t,        // Assignem el valor de nom_t a nom
      horari: horari_t,   // Assignem el valor d'horari_t a horari
      ...rest           // Posem tota la resta de dades
    }));
    const worksheet = XLSX.utils.json_to_sheet(dadesNetejades);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Extraescolars");

    // Generem el fitxer i forcem la descàrrega al navegador
    XLSX.writeFile(workbook, "exportacio_extraescolars.xlsx");
  };





  //CERCA
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [searchInput, setSearchInput] = useState([]);
  //FI CERCA

  const buscarDades = async () => {

    const c = await Api.get('/cursos');
    if(c.result.success!==1){return [];}

    const cursos = c.data.cursos.reduce((acumulat, item) => ({
      ...acumulat,
      [item.id]: item.nom_curt,
    }),{});

    //console.log('cursos',cursos);

    const e = await Api.get(`/extraescolars/curs/${cursEscolarTriat}`);
    if(e.result.success===1){
      const extra = e.data.extraescolars.map((item)=>{
        item.nom_t = entities.decode(item.nom[props.t('idioma')]);
        //FALLA FORMULARI item.nom = item.nom_t;
        item.horari_t = entities.decode(item.horari[props.t('idioma')]);
        //FALLA FORMULARI item.horari = item.horari_t;
        /*const tags = item.cursos.map((curs) => {
          return <span>{cursos[curs]}&nbsp;</span>;
        });*/
        //console.log('item.cursos',item.cursos);
        const curs_llista = item.cursos.map(curs => cursos[curs]).join(', ');
        item.curs_llista = curs_llista;
        //console.log('curs_llista', curs_llista);

        const mesos_llista = item.mesos_facturacio.map(mes => mes).join(', ');
        item.mes_llista = mesos_llista;
        return item;
      });
      setDadesActuals(extra);
      return extra;
    }

  }

  const marcarEliminat = async (id) => {

    const fam = await Api.myFetch('/extraescolars/'+id, 'DELETE');
    if(fam.result.success===1){

    }

  }

  const triaCursChange = (curs) => {
    setCursEscolarTriat(curs);
    setRefrescar(refrescar+1);
  }

  //CERCA
    const getColumnSearchProps = (dataIndex, nom) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              let search = searchInput;
              search[dataIndex] = node;
              setSearchInput(search);
            }}
            placeholder={`${props.t('generic.cercar')} ${nom}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            autoFocus="focus"
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              {props.t('generic.cercar')}
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
        record[dataIndex] ? arreglarTxt4Search(entities.decode(record[dataIndex].toString())).includes(arreglarTxt4Search(value)) : '',
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => searchInput[dataIndex].select(),100);
        }
      },
     render: text => (entities.decode(text)),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };

    const handleReset = clearFilters => {
      clearFilters();
      setSearchText('');
    };

    const arreglarTxt4Search = text =>{
        // Poso en minuscules, normalitzo caracters treure accents i ñ , elimina els caracters diacrítics raros d'un text (ES6)
        //return text.trim().split(' ')[0].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
        return text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
    }
  //FI CERCA

  const columns = [
    {
      title:"Id",
      key:"id",
      sorter: (a, b) =>  a.id - b.id,
      render: (text,record) => (<span>{record.id}</span>)
    },{
      title: props.t('transport.ordre'),
      key:"ordre",
      sorter: (a, b) =>  a.ordre - b.ordre,
      render: (text,record) => (<span>{record.ordre}</span>)
    },{
      title: props.t('extraescolars.nom'),
      key:"nom_t",
      dataIndex: 'nom_t',
      sorter: (a, b) => { return a.nom_t.localeCompare(b.nom_t)},
      ...getColumnSearchProps('nom_t',props.t('extraescolars.nom'))
    },{
      title: props.t('extraescolars.horari'),
      key:"horari_t",
      dataIndex: 'horari_t',
      sorter: (a, b) => { return a.horari_t.localeCompare(b.horari_t)},
      ...getColumnSearchProps('horari_t',props.t('extraescolars.horari'))
    },{
      title: (
        <Tooltip title={props.t('generic.hfin')}>
          HF
        </Tooltip>
      ),
      key:"hora_fin",
      sorter: (a, b) =>  (a.hora_fin*60+a.minut_fin) - (b.hora_fin*60+b.minut_fin),
      render:(text,record) => record.horari_especial == 0 ? (<span>{record.hora_fin}h{record.minut_fin}m</span>) : null
    },{
      title: props.t('generic.preu'),
      key:"preu",
      sorter: (a, b) =>  a.preu - b.preu,
      render:(text,record) => (<span>{record.preu}€</span>)
    },{
      title: props.t('quotes.cursos'),
      ellipsis: true,
      key:"cursos",
      render:(text,record) =>(<span>{record.curs_llista}</span>)
    },{
      title: props.t('generic.fini'),
      key:"fini",
      sorter: (a, b) => moment(a.fini).diff(moment(b.fini)),
      responsive:['md'],
      render:(text,record) => (record.fini ? <Moment date={moment(record.fini)} format="DD/MM/YYYY HH:mm"/> : "" )
    },{
      title: props.t('generic.ffin'),
      key:"fini",
      sorter: (a, b) => moment(a.ffin).diff(moment(b.ffin)),
      responsive:['md'],
      render:(text,record) => (record.ffin ? <Moment date={moment(record.ffin)} format="DD/MM/YYYY HH:mm"/> : "" )
    },{
      title: (
        <Tooltip title={props.t('generic.horari_especial')}>
          HE
        </Tooltip>
      ),
      key:"horari_especial",
      render:(text,record) =>(<span>{record.horari_especial}</span>)
    },{
      title: (<Tooltip title={props.t('dies.dilluns')}>L</Tooltip>),
      key:"dilluns",
      render:(text,record) =>(<span>{record.dilluns}</span>)
    },{
      title: (<Tooltip title={props.t('dies.dimarts')}>M</Tooltip>),
      key:"dimarts",
      render:(text,record) =>(<span>{record.dimarts}</span>)
    },{
      title: (<Tooltip title={props.t('dies.dimecres')}>M</Tooltip>),
      key:"dimecres",
      render:(text,record) =>(<span>{record.dimecres}</span>)
    },{
      title: (<Tooltip title={props.t('dies.dijous')}>J</Tooltip>),
      key:"dijous",
      render:(text,record) =>(<span>{record.dijous}</span>)
    },{
      title: (<Tooltip title={props.t('dies.divendres')}>V</Tooltip>),
      key:"divendres",
      render:(text,record) =>(<span>{record.divendres}</span>)
    },{
      title: (<Tooltip title={props.t('dies.dissabte')}>S</Tooltip>),
      key:"dissabte",
      render:(text,record) =>(<span>{record.dissabte}</span>)
    },{
      title: (<Tooltip title={props.t('dies.diumenge')}>D</Tooltip>),
      key:"diumenge",
      render:(text,record) =>(<span>{record.diumenge}</span>)
    }
  ];

  return(
    <ContainerPagina xl={24}>
      <TitolPagina txt={props.t('menu.Extraescolars')}/>
      <div style={{marginTop:'1rem', marginLeft:'3rem'}}>

        <LlistaEditable

          //dadesMostradesCallback={(dadesMostrades) => {
            //setDadesActuals(dadesMostrades);
          //}}
          onChange={handleTableChange}
          id_curs_escolar={cursEscolarTriat}
          btn_extra={
          <>
            <Button type="primary"
              style={{backgroundColor: '#217346', borderColor: '#217346'}}
              shape="round"
              icon={<FileExcelOutlined />}
              onClick={exportarAExcel}>
              Exportar a Excel ({dadesActuals.length} files)
            </Button>
            <TriaCursEscolar defaultValue={cursEscolarTriat} onChange={(c) => triaCursChange(c)}/>
          </>
          }
          txt_creats={props.t('extraescolars.creados')}
          txt_nou={props.t('extraescolars.nuevo')}
          buscarDades={buscarDades}
          refrescar={refrescar}
          edit={Edit}
          delete={marcarEliminat}
          duplica={true}
          itemBuit={InitDades.extraescolars()}
          columns={columns}/>
          {/*<Column
          title="Id"
          key="id"
          sorter={(a, b) =>  (a.id - b.id)}
          render={(text,record) => (
            <span>{record.id}</span>
          )}
          />
          <Column
          title={props.t('transport.ordre')}
          key="ordre"
          sorter={(a, b) =>  (a.ordre - b.ordre)}
          render={(text,record) => (
            <span>{record.ordre}</span>
          )}
          />
          <Column
          title={props.t('extraescolars.nom')}
          key="nom_t"
          dataIndex="nom_t"
          sorter={(a, b) =>  (a.nom_t.localeCompare(b.nom_t))}
          />
          <Column
          title={props.t('extraescolars.horari')}
          key="horari"
          render={(text,record) =>(
            entities.decode(record.horari[props.t('idioma')])
          )}
          />


        </LlistaEditable>*/}
      </div>
    </ContainerPagina>
  );

}

export default translate(Extraescolars);
